import { Box, Divider, Typography } from '@mui/material';

import type { FactsheetDetails } from '@/features/Factsheet/types';
import { parseVersionHistoryText } from '@/features/Factsheet/utils/versionHistory';

import TextLinesDisplay from './TextLinesDisplay';

interface ApproachTabProps {
  factsheet: FactsheetDetails;
}

interface TradeDataRowProps {
  label: string;
  value: boolean | string | undefined;
}

const TradeDataRow = ({ label, value }: TradeDataRowProps) => (
  <Box
    display='flex'
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      pt: 0.5
    }}
  >
    <Typography>{label}</Typography>
    <Typography>{value ? 'Y' : 'N'}</Typography>
  </Box>
);

const TradeDataApproachSection = ({ factsheet }: { factsheet: FactsheetDetails }) => (
  <Box
    display='flex'
    sx={{ minWidth: '50%', maxWidth: '50%', flexDirection: 'column', pl: 1, pr: 2 }}
  >
    <Box
      display='flex'
      sx={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 0.5
      }}
    >
      <Typography
        sx={{ fontWeight: 700 }}
        variant='body2'
      >
        Trade Data Approach
      </Typography>
      <Typography
        sx={{ fontWeight: 700 }}
        variant='body2'
      >
        Y/N
      </Typography>
    </Box>
    <Divider sx={{ backgroundColor: 'text.primary', pr: 4 }} />
    <TradeDataRow
      label='Priority to reported and concluded transactions'
      value={factsheet.priorityToTransactions}
    />
    <TradeDataRow
      label='Sole-sourced data from trading principals accepted'
      value={factsheet.soleSourcedDataAccepted}
    />
    <TradeDataRow
      label='Inter-affiliate data accepted as valid'
      value={factsheet.interAffiliateDataAccepted}
    />
  </Box>
);

const ApproachTab = ({ factsheet }: ApproachTabProps) => {
  const approachLines = parseVersionHistoryText(factsheet, 'calculationApproach');

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
      <TradeDataApproachSection factsheet={factsheet} />
      <Box
        display='flex'
        sx={{ flexDirection: 'column', pr: 1, pl: 2 }}
      >
        <TextLinesDisplay lines={approachLines} />
      </Box>
    </Box>
  );
};

export default ApproachTab;
